/*
 * @date :2021-03-09
 * @description：图文问诊模块路由
 */
const prefix = '/hospital/';
const route = [
  {
    path: `${prefix}chat`,
    name: 'Chat',
    component: () => import(/* webpackPrefetchPlaceHolder */ './chat'),
    auth: true,
    exact: true,
    title: '图文问诊交流',
  },
  {
    path: `${prefix}chat/check`,
    name: 'Chat',
    component: () => import(/* webpackPrefetchPlaceHolder */ './chat'),
    auth: true,
    exact: true,
    title: '图文问诊交流',
  },
  {
    path: `${prefix}await/old`,
    name: 'Await',
    component: () => import(/* webpackPrefetchPlaceHolder */ './await'),
    auth: true,
    exact: true,
    title: '订单分配中',
  },
  {
    path: `${prefix}await`,
    name: 'Await',
    component: () => import(/* webpackPrefetchPlaceHolder */ 'src/pages/inquiryForm/aiGuideNext/index'),
    auth: true,
    exact: true,
    title: '订单分配中',
    keepAlive: true,
  },
  {
    path: `${prefix}inquiryApplyList`,
    name: 'InquiryApplyList',
    component: () => import(/* webpackPrefetchPlaceHolder */ 'src/pages/inquiryForm/inquiryApplyList'),
    auth: true,
    exact: true,
    title: '众安互联网医院',
  },
];

export default route;
